

import { $ } from "../third-party-imports";

export function bannerTxtLeftSpace()
{
    let offset = $('footer .container').offset();
    $('.bannerTopBox.js-left-spacing').css('padding-left', offset.left);
}
